import React, { useState, useEffect } from 'react';
import { Modal } from '../../design-system';
import { BUTTON_PRESETS } from '../../design-system/constants';
import { Form, InputNumber, DatePicker, message } from 'antd';
import ApiServiceNode from '../../service/ApiServiceNode';
import moment from 'moment';
import logger from '../../utils/logger';



const CostRateFormModal = ({ visible, costRate, officeId, currency, onClose }) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (visible) {
            if (costRate) {
                form.setFieldsValue({
                    amount: costRate.amount,
                    hourly_rate: costRate.hourly_rate,
                    valid_at: costRate.valid_at ? moment(costRate.valid_at) : null
                });
            } else {
                form.resetFields();
            }
        }
    }, [visible, costRate, form]);

    const handleSave = async () => {
        try {
            const values = await form.validateFields();
            setLoading(true);

            const costRateData = {
                office_id: officeId,
                amount: values.amount,
                hourly_rate: values.hourly_rate,
                valid_at: values.valid_at.format('YYYY-MM-DD')
            };

            if (costRate) {
                await ApiServiceNode.put(`/settings/offices/cost-rates/${costRate.id}`, costRateData);
                message.success('Cost rate updated successfully');
            } else {
                await ApiServiceNode.post('/settings/offices/cost-rates', costRateData);
                message.success('Cost rate created successfully');
            }

            onClose(true); // Refresh list
        } catch (error) {
            logger.error('Error saving cost rate:', error);
            message.error('Failed to save cost rate');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal visible={visible} onClose={() => onClose(false)} width="medium">
            <Modal.Header title={costRate ? 'Edit Cost Rate' : 'Add Cost Rate'} />
            <Modal.Body padding="default">
                <Form form={form} layout="vertical">
                    <Form.Item
                        label="Monthly"
                        name="amount"
                        rules={[
                            { required: true, message: 'Please enter monthly amount' },
                            { type: 'number', min: 0, message: 'Amount must be positive' }
                        ]}
                    >
                        <InputNumber
                            prefix={currency || '$'}
                            placeholder="e.g., 17600"
                            style={{ width: '100%' }}
                            precision={2}
                            step={100}
                        />
                    </Form.Item>

                    <Form.Item
                        label="Hourly"
                        name="hourly_rate"
                        rules={[
                            { required: true, message: 'Please enter hourly rate' },
                            { type: 'number', min: 0, message: 'Rate must be positive' }
                        ]}
                        help="Formula: Salary/22/8"
                    >
                        <InputNumber
                            prefix={currency || '$'}
                            placeholder="e.g., 100"
                            style={{ width: '100%' }}
                            precision={2}
                            step={1}
                        />
                    </Form.Item>

                    <Form.Item
                        label="Valid At"
                        name="valid_at"
                        rules={[
                            { required: true, message: 'Please select valid date' }
                        ]}
                    >
                        <DatePicker
                            format="DD/MM/YYYY"
                            placeholder="Select Date"
                            style={{ width: '100%' }}
                        />
                    </Form.Item>
                </Form>
            </Modal.Body>
            <Modal.Footer buttons={[
                {
                    ...BUTTON_PRESETS.SAVE,
                    label: costRate ? 'Update' : 'Create',
                    loading,
                    onClick: handleSave
                }
            ]} />
        </Modal>
    );
};

export default CostRateFormModal;
